import { styled } from '../../Utilities';
import { KeytipLayerBase } from './KeytipLayer.base';
import { getStyles } from './KeytipLayer.styles';
export var KeytipLayer = styled(KeytipLayerBase, getStyles, undefined, {
    scope: 'KeytipLayer'
});
//# sourceMappingURL=KeytipLayer.js.map